var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
export var CameraVideo = function CameraVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5a2 2 0 00-2 2v9.527a2 2 0 002 2h10.204a2 2 0 002-2v-2.836l3.108 3.333c.924.99 2.583.347 2.597-1.007L22 7.39c.015-1.319-1.557-2.012-2.522-1.113l-3.273 3.052V7a2 2 0 00-2-2H4z",
    fill: "currentColor"
  })));
};